import React, { useEffect, useState } from 'react';
import IconTip from '@/components/icon-tip';
import './index.less';
import apis from '../../api';
import { useHistory } from 'react-router-dom';
import ComponentLog from '@/components/component-log';
import { CaretRightOutlined } from '@ant-design/icons';

const MicroEntry = (props) => {
  const history = useHistory();
  const [statusData, setData] = useState({});
  useEffect(() => {
    apis.channelMicroStatusCount({ type: 1 }).then((res) => {
      const { ret, data } = res;
      if (ret === '0') {
        setData(data);
      }
    });
  }, []);

  return (
    <div className="micro-entry-block">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span className="micro-entry-title">
          微频道
          <IconTip
            color={'#8C8C8C'}
            title={<div>微频道是针对特定品类和营销场景，通过页面模版快捷搭建的营销场。</div>}
            type="question"
          />
        </span>
        <ComponentLog>
          <span
            clstag="yx_center|workbench_microchannelclick"
            style={{ cursor: 'pointer' }}
            onClick={() => history.push('/channel-micro/my-manager')}
            className="micro-entry-title-inter"
          >
            进入频道
            <CaretRightOutlined />
          </span>
        </ComponentLog>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
        <ComponentLog>
          <div
            clstag="yx_center|workbench_microchannelrejected"
            style={{ marginRight: '12px' }}
            onClick={() => history.push('/channel-micro/my-manager')}
            className="block-sub-title"
          >
            被驳回
            <span style={{ color: '#FF4C4C', lineHeight: '20px', cursor: 'pointer', marginLeft: 8 }}>
              {statusData.reject ? statusData.reject : 0} &gt;
            </span>
          </div>
          <div
            className="block-sub-title"
            clstag="yx_center|workbench_microchannelaudit"
            onClick={() => history.push('/channel-micro/my-approve')}
          >
            待审核
            <span style={{ color: '#2D64FF', lineHeight: '20px', cursor: 'pointer', marginLeft: 8 }}>
              {statusData.approve ? statusData.approve : 0} &gt;
            </span>
          </div>
        </ComponentLog>
      </div>
    </div>
  );
};
export default MicroEntry;
